import { Type } from '@angular/core';
import { FeaturedLiteratureComponent } from './featured-literature/featured-literature.component';
import { ItemDetailComponent } from './item-detail/item-detail.component';
import { LiteratureDocumentCartComponent } from './literature-document-cart/literature-document-cart.component';
import { LiteratureDocumentListingComponent } from './literature-document-listing/literature-document-listing.component';
import { OrderHistoryListComponent } from './order-history-list/order-history-list.component';
import { LiteratureOrderHistoryDetailComponent } from './literature-order-history-detail/literature-order-history-detail.component';
import { TopFormsComponent } from './top-forms/top-forms.component';
import { LiteratureYourCartMailComponent } from './literature-your-cart-mail/literature-your-cart-mail.component';
import { LiteratureYourCartMailConfirmOrderComponent } from './literature-your-cart-mail-confirm-order/literature-your-cart-mail-confirm-order.component';
import { LiteratureYourCartMailOrderSuccessComponent } from './literature-your-cart-mail-order-success/literature-your-cart-mail-order-success.component';
import { MyCartSummaryComponent } from './my-cart-summary/my-cart-summary.component';
import { ComplimentaryLiteratureComponent } from './complementary-literature/complementary-literature.component';
import { LiteratureDashboardComponent } from './literature-dashboard/literature-dashboard.component';
import { MyLiteratureComponent } from './my-literature/my-literature.component';
import { SmarshLiteratureListingComponent } from './smarsh-literature-listing/smarsh-literature-listing.component';
export class LiteratureComponentConfig {
  static readonly LITERATURE_DOCUMENT_LISTING = new LiteratureComponentConfig(
    'Literature Document Listing',
    LiteratureDocumentListingComponent
  );
  static readonly TOP_FORMS = new LiteratureComponentConfig(
    'Top Forms',
    TopFormsComponent
  );
  static readonly FEATURED_LITERATURE = new LiteratureComponentConfig(
    'Featured Literature',
    FeaturedLiteratureComponent
  );
  static readonly LITERATURE_CART = new LiteratureComponentConfig(
    'Your Cart Checkout',
    LiteratureDocumentCartComponent
  );
  static readonly ORDER_HISTORY_LIST = new LiteratureComponentConfig(
    'Order History List',
    OrderHistoryListComponent
  );
  static readonly CART_DELIVERY_ADDRESS = new LiteratureComponentConfig(
    'Cart Delivery Address',
    LiteratureYourCartMailComponent
  );
  static readonly CART_CONFIRM_ORDER = new LiteratureComponentConfig(
    'Cart Confirm Order',
    LiteratureYourCartMailConfirmOrderComponent
  );
  static readonly CART_CHECKOUT_COMPLETE = new LiteratureComponentConfig(
    'Cart Checkout Complete',
    LiteratureYourCartMailOrderSuccessComponent
  );

  static readonly CART_SUMMARY = new LiteratureComponentConfig(
    'Cart Summary',
    MyCartSummaryComponent
  );

  static readonly LITERATURE_HOME_PAGE = new LiteratureComponentConfig(
    'My Literature Homepage',
    LiteratureDashboardComponent
  );

  static readonly MY_LITERATURE = new LiteratureComponentConfig(
    'My Literature',
    MyLiteratureComponent
  );

  static allConfigs: LiteratureComponentConfig[] = [
    LiteratureComponentConfig.TOP_FORMS,
    LiteratureComponentConfig.FEATURED_LITERATURE,
    LiteratureComponentConfig.LITERATURE_DOCUMENT_LISTING,
    LiteratureComponentConfig.LITERATURE_CART,
    LiteratureComponentConfig.ORDER_HISTORY_LIST,
    LiteratureComponentConfig.CART_DELIVERY_ADDRESS,
    LiteratureComponentConfig.CART_CONFIRM_ORDER,
    LiteratureComponentConfig.CART_CHECKOUT_COMPLETE,
    LiteratureComponentConfig.CART_SUMMARY,
    LiteratureComponentConfig.LITERATURE_HOME_PAGE,
    LiteratureComponentConfig.MY_LITERATURE,
    // LiteratureComponentConfig.SMARSH_LITERATURE_DOCUMENT_LISTING,
  ];

  // returns matching config or undefined
  static getConfig(key: string): LiteratureComponentConfig {
    return this.allConfigs.find(
      (config: LiteratureComponentConfig): boolean => config.key === key
    );
  }

  private constructor(
    public readonly key: string,
    public readonly component: Type<any>
  ) {}
}
